import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static item(postId) {
        return PostApiBase.sitePost({
            post_id: postId
        }).then((resp) => {
            return resp.data["item"]
        })
    }

    static saveDraft(q) {
        return PostApiBase.siteSaveDraft(q).then((resp) => {
            return resp.data["item"]
        })
    }

    static createDraft(q) {
        return PostApiBase.siteCreateDraft(q).then((resp) => {
            return resp.data["id"]
        })
    }

    static publishedSales(q) {
        return PostApiBase.siteSalesPublished(q)
    }

    static publishedArticles(q) {
        return PostApiBase.siteArticlesPublished(q)
    }

    static publishedNotes(q) {
        return PostApiBase.siteNotesPublished(q)
    }

    static publishedPromocode(q) {
        return PostApiBase.sitePromocodePublished(q)
    }

    static scheduledSales(q) {
        return PostApiBase.siteSalesScheduled(q)
    }

    static scheduledArticles(q) {
        return PostApiBase.siteArticlesScheduled(q)
    }

    static scheduledNotes(q) {
        return PostApiBase.siteNotesScheduled(q)
    }

    static scheduledPromocode(q) {
        return PostApiBase.sitePromocodeScheduled(q)
    }

    static saveSales(q) {
        return PostApiBase.siteSalesSave(q)
    }

    static saveArticles(q) {
        return PostApiBase.siteArticlesSave(q)
    }

    static saveNotes(q) {
        return PostApiBase.siteNotesSave(q)
    }

    static savePromocode(q) {
        return PostApiBase.sitePromocodeSave(q)
    }

    static saveDelete(q) {
        return PostApiBase.saveDelete(q)
    }

    static chainBindInPost(thisObjectId, thatObjectId, thisTypeId, thatTypeId) {
        return PostApiBase.chainBindInPost({
            this_object_id: thisObjectId,
            that_object_id: thatObjectId,
            this_type_id: thisTypeId,
            that_type_id: thatTypeId,
        }).then((resp) => {
            return resp.data
        })
    }
}
